var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.991 2.96069C13.0121 2.42412 13.4532 2 13.9902 2H14.0098C14.5468 2 14.9879 2.42412 15.009 2.96069C15.2445 8.94519 19.0548 12.7555 25.0393 12.991C25.5759 13.0121 26 13.4532 26 13.9902V14.0098C26 14.5468 25.5759 14.9879 25.0393 15.009C19.0548 15.2445 15.2445 19.0548 15.009 25.0393C14.9879 25.5759 14.5468 26 14.0098 26H13.9902C13.4532 26 13.0121 25.5759 12.991 25.0393C12.7555 19.0548 8.94519 15.2445 2.96069 15.009C2.42412 14.9879 2 14.5468 2 14.0098V13.9902C2 13.4532 2.42412 13.0121 2.96069 12.991C8.94519 12.7555 12.7555 8.94519 12.991 2.96069ZM14 7.60825C12.6306 10.9558 10.9558 12.6306 7.60825 14C10.9558 15.3694 12.6306 17.0442 14 20.3917C15.3694 17.0442 17.0442 15.3694 20.3917 14C17.0442 12.6306 15.3694 10.9558 14 7.60825Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleOutline);
export default __webpack_public_path__ + "static/media/sparkle_outline.02b9e59c1cf6ea48f112695a113fe6ca.svg";
export { ForwardRef as ReactComponent };